import React, { useEffect, useState, useRef } from "react";
import { useSelector, useDispatch } from 'react-redux';
import * as S from '../scss/theme';
import fnc from "../mymod/commFunction";
import './RegSchTec.scss';
import HongButton from "../comm/HongButton";
import HongInput from "../comm/HongInput";
import Combobox from "../comm/Combobox";
import HeaderTitle from "../comm/HeaderTitle";

import { useNavigate } from "react-router-dom";
import { setActiveLink, setIsLoggedIn, setUserInfo, setUserName } from "../reduxToolkit/reduxIgong";

const RegSchTec = () => {
    const {orgCode, stCode: parentCode} = useSelector(state => state.reduxIgong.userInfo);
    const navigate = useNavigate();
    const dispatch = useDispatch();
    
    const [userId, setUserId] = useState(null);
    const [userHp, setUserHp] = useState(null);
    const [userName, setUserName] = useState(null);
    const [isRefresh, setIsRefresh] = useState(false);

    const [selectedSno, setSelectedSno] = useState(null);
    const [kwamokList, setKwamokList] = useState([]);
    const [selectedKwamokObj, setSelectedKwamokObj] = useState({});

    const [list, setList] = useState([]);
    const [stCode, setStCode] = useState(null);

    useEffect(() => {
     
        fncSelect_kwamok();  
        fncSelect_list();

      }, [isRefresh]);
  
    
      
    
  function fncSelect_kwamok() {
    const eduKind = '학원';

    fnc.sendAxios('/settingsRoutes/select/kwamok', { eduKind }, (res) => {
      if (res && Array.isArray(res)) { 
        const cmbListKwamok = getRecords_kwamok(res);
        setKwamokList(cmbListKwamok);

 
      } else {
        console.log(res,"kuesbBasicSettingRoutes/select/basic/group/kwamok");
      }
    });
  }
    
 function getRecords_kwamok(res) {
    let records = [];
    
    for (let i = 0; i < res.length; i++) {      
          const kwamokCode = res[i]["kwamokCode"];
          const kwamok = res[i]["kwamok"];
          records.push({ value: kwamokCode, label: kwamok });
    }
    return records;
  }

  function onChange_kwamok(e) {
    const index = e.target.selectedIndex;
    setSelectedKwamokObj(kwamokList[index - 1]);
  }



  
  function fncSelect_list() {
    fnc.sendAxios('/igongLogin_schTecRoutes/select/user_tec', { orgCode, parentCode }, (res) => {
      if (res && Array.isArray(res)) { 
        const newList = getRecords(res);
        setList(newList);
      } else {
        console.log(res,"select/basic/group/groupList");
      }
    });
  }

  
  function getRecords(res) {
    let records = [];
    for (let i = 0; i < res.length; i++) { 
        const sno = res[i]["sno"];  
        const orgCode = res[i]["orgCode"];
        const stCode = res[i]["stCode"];
        const userHp = res[i]["userHp"];
        const userId = res[i]["userId"];
        const kwamokCode = res[i]["kwamokCode"];
        const kwamok = res[i]["kwamok"];
        const userName = res[i]["userName"];
        let sDate = res[i]["sDate"];
        sDate = fnc.formatDate2(sDate);    
        records.push({ sno, orgCode, stCode, userHp, kwamokCode, kwamok, userId, userName, sDate });
    }
    return records;
  }


  
  function onClickTr( item, index) {
    setSelectedSno(item.sno);
    setUserId(item.userId);
    setUserHp(item.userHp);
    setUserName(item.userName);
    setSelectedKwamokObj({ value: item.kwamokCode, label: item.kwamok });
    setStCode(item.stCode);
  }

  //--------------------------------------------------
  
  function onInsert() {

    let userPw;
    
    const phonePattern = /^[0-9]{10,11}$/;

    if (!userId) {
        alert( '휴대전화 번호를 입력해 주세요.');
        return false;
    } else if (!phonePattern.test(userId)) {
        alert('유효한 휴대전화 번호를 입력해 주세요.');
        return false;
    }

    if (!userHp) {
      alert( '휴대전화 번호를 입력해 주세요.');
      return false;
    } else if (!phonePattern.test(userHp)) {
      alert('유효한 휴대전화 번호를 입력해 주세요.');
      return false;
    }

    userPw = userHp?.slice(-4);//핸폰 뒷번호 4자리


    if(!userName) {
        alert('이름을 입력하세요!');
        return null;
    }

    if(!selectedKwamokObj?.value) {
        alert('과목을 선택하세요!');
        return null;
    }

    const rtn = window.confirm(`${userName}을 추가하시겠습니까?`);
    if (!rtn) return;

    fnc.sendAxios('/igongLogin_schTecRoutes/insert/user_tec', { 
        orgCode, 
        parentCode,
        hp : userHp, 
        userId: userId, 
        password: userPw, 
        userName,
        kwamokCode: selectedKwamokObj.value}, (res) => {
        if (!res) {
            alert('가입에 실패했습니다.');
            return;
        }
        
        if (res.success === 'exist') {
            alert('이미 존재하는 아이디입니다. \n복원하려면 관리자에게 문의하세요!');
        } else if (res.success === true) {
            onRefresh();
        }
    });
  }

  
function onDelete() {
    if(!setSelectedSno) {
      alert('대상을 선택하세요!');
      return null;
    }

    const rtn = window.confirm(`${userName}(${userHp})을 삭제하시겠습니까?`);
    if(!rtn) return;

    fnc.sendAxios('/igongLogin_schTecRoutes/deleteUpdate/user_tec', { orgCode, stCode }, (res) => {
      if (res) { 
          setIsRefresh(!isRefresh);
      } else {
        alert('삭제에 실패했습니다.');
      }
    }); 
}


function onUpdate() {
    if(!setSelectedSno) {
      alert('대상을 선택하세요!');
      return null;
    }

    const rtn = window.confirm(`${userName}(${userHp})을 수정하시겠습니까?`);
    if(!rtn) return;

    fnc.sendAxios('/igongLogin_schTecRoutes/update/user_tec', { 
        orgCode, stCode, userHp, userName, 
        kwamokCode: selectedKwamokObj.value
     }, (res) => {
      if (res) { 
          setIsRefresh(!isRefresh);
      } else {
        alert('삭제에 실패했습니다.');
      }
    }); 
}

  
function onRefresh() {
    setIsRefresh(!isRefresh);
}

function fncBack() {
  navigate(-1);
}

    //=============================================
    return (
        <S.Section>
           <HeaderTitle title={'학교 교사 등록'} onBackClick={fncBack} direction={1} />
            <div className="RegSchTec">
                <section className='sec-main'>
                    <table className="table-hong table-main">
                    <thead>
                        <tr>
                        <th>No</th>
                        <th>아이디</th>
                        <th>핸드폰</th>     
                        <th>이름</th>
                        <th>과목</th>
                        <th>가입일</th>
                        </tr>
                    </thead>

                    <tbody>
                        {list && list.map((item, index) => (
        
                            <tr key={index} onClick={() => onClickTr(item, index)}
                                className={selectedSno === item.sno ? 'selected' : ''}>  
                                <td>{index+1}</td>
                                <td>{item.userId}</td>
                                <td>{item.userHp}</td>  
                                <td>{item.userName}</td>
                                <td>{item.kwamok}</td>
                                <td>{item.sDate}</td>
                            </tr>
                        ))}
                    
                        </tbody>

                    </table>

                </section> 

                <section className="sec-footer">
                    <article className='art-input'>
                        <div className='box-cmb'>
                            <span className='lbl-cmb'>*아이디(핸드폰)을 입력하세요!</span>
                            <div className='cmb'>
                                <HongInput 
                                    className='txtGroupName' 
                                    value={userId}
                                    spellCheck='false'
                                    onChange={(e) => { setUserId(e.target.value); setUserHp(e.target.value) }}
                                    placeholder='- 없이 입력해주세요.'>
                                </HongInput>
                            </div>  
                        </div>

                         <div className='box-cmb'>
                            <span className='lbl-cmb'>*핸드폰을 입력하세요!</span>
                            <div className='cmb'>
                                <HongInput 
                                    className='txtGroupName' 
                                    value={userHp}
                                    spellCheck='false'
                                    onChange={(e) => setUserHp(e.target.value)}
                                    placeholder='- 없이 입력해주세요.'>
                                </HongInput>
                            </div>  
                        </div>

                        <div className='box-cmb'>
                            <span className='lbl-cmb'>*이름을 입력하세요!</span>
                            <div className='cmb'>
                                <HongInput 
                                    className='txtGroupName' 
                                    value={userName}
                                    spellCheck='false'
                                    onChange={(e) => setUserName(e.target.value)}
                                    placeholder='이름을 입력해주세요.'>
                                </HongInput>
                            </div>  
                        </div>

                        <div className='box-cmb'>
                            <span className='lbl-cmb'>*과목을 선택하세요!</span>
                            <div className='cmb'>
                            <select
                                className="txtGroupName"
                                value={selectedKwamokObj.value || ''}
                                onChange={onChange_kwamok}
                            >
                            <option value="" disabled>과목을 선택하세요!</option>
                                {kwamokList?.map((item) => (
                                <option key={item.value} value={item.value}>
                                    {item.label}
                                </option>
                                ))}
                            </select>
                            </div>  
                        </div>  

                    </article>

                    <article className='art-btn'>
                        <HongButton className='btn h-btn-pre' onClick={fncBack}>이전으로</HongButton> 
                        <HongButton className='btn h-btn-refresh' onClick={onRefresh}>새로고침</HongButton> 
                        <HongButton className='btn h-btn-insert' onClick={onInsert}>추가</HongButton> 
                        <HongButton className='btn h-btn-update' onClick={onUpdate}>수정</HongButton> 
                        <HongButton className='btn h-btn-delete' onClick={onDelete}>삭제</HongButton> 
                       
                    </article>  

                </section>

            </div>


        </S.Section>
    );
};

export default RegSchTec;
